<div class="sp-seller-details-general__grid sp-min-height__full">
  <app-seller-details-general-info
    *ngIf="!(is_read_running || is_read_stores_running)"
    class="sp-seller-details-general__info"
    [seller]="seller"></app-seller-details-general-info>

  <app-seller-details-general-stores
    class="sp-seller-details-general__stores"
    *ngIf="!(is_read_running || is_read_stores_running)"
    [stores]="stores || []"></app-seller-details-general-stores>

  <app-loading
    *ngIf="is_read_running || is_read_stores_running"
    class="sp-seller-details-general__info sp-seller-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running || is_read_stores_running"
    class="sp-seller-details-general__stores sp-seller-details-general__loading"></app-loading>
</div>
